//carousel
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import './videoCarousel.css';
import {Carousel} from 'react-responsive-carousel';
//components
import {Typography} from '@material-ui/core';

function VideoCarousel(props: any) {
  //functions
  const customRenderThumb = (children: any) =>
    children.map((item: any, index: number) => {
      return (
        <img
          style={{
            backgroundImage: "url('/video/background.svg')",
          }}
          className="image"
          src={`/video/${props.video[0]}.svg`}
          key={index}
        />
      );
    });
  //JSX
  return (
    <Carousel
      className={props.video[1].videos.length == 1 ? 'transition' : null}
      autoPlay={false}
      selectedItem={0}
      emulateTouch={true}
      showArrows={false}
      showThumbs={true}
      showStatus={false}
      infiniteLoop={true}
      renderThumbs={customRenderThumb}
      onChange={(index: number) =>
        props.clickThumbHandler(props.video[1].videos[index])
      }
      renderArrowPrev={(clickHandler, hasPrev) => {
        if (props.video[1].videos.length > 1) {
          return (
            <div className="changeicon" onClick={clickHandler}>
              <div className="prevIcon"></div>
            </div>
          );
        }
      }}
      renderArrowNext={(clickHandler, hasNext) => {
        if (props.video[1].videos.length > 1) {
          return (
            <div className="changeicon" onClick={clickHandler}>
              <div className="nextIcon"></div>
            </div>
          );
        }
      }}
    >
      {props.video[1].videos.map((arr: any, index: number) => {
        return (
          <div key={index}>
            <Typography className="topic">{arr.name}</Typography>
            <iframe
              src={arr.aparatUrl}
              allowFullScreen={true}
              width="150"
              height="350"
              style={{borderRadius: '20px'}}
            ></iframe>
          </div>
        );
      })}
    </Carousel>
  );
}

export default VideoCarousel;
